import mutations from './mutations';
import { DataService } from '@/config/dataService/dataService';
import { notification } from 'ant-design-vue';

const state = () => ({
    data: [],
    loading: false,
    error: null,
    total: 0,
    currentItem: {},
});

const actions = {
    async contactReadAll({commit}, payload) {
        try {
            await commit('contactReadAllBegin');
            const response = await DataService.get(`/contacts?${new URLSearchParams(payload).toString()}`);
            await commit('contactReadAllSuccess', response.data.data);
        } catch (err) {
            commit('contactReadAllErr', err);
        }
    },

    async contactAdd({commit}, payload) {
        try {
            await commit('contactAddBegin');
            const response = await DataService.post('/contacts', payload);
            await commit('contactAddSuccess', response.data.data);

            notification.success({
                message: response.data.message,
                placement: 'topRight'
            });
        } catch (err) {
            commit('contactAddErr', err);

            notification.error({
                message: err.message,
                placement: 'topRight'
            });
        }
    },

    async contactUpdate({commit}, payload) {
        try {
            await commit('contactUpdateBegin');
            const response = await DataService.put(`/contacts/${payload.id}`, payload);
            await commit('contactUpdateSuccess', response.data.data);

            notification.success({
                message: response.data.message,
                placement: 'topRight'
            });
        } catch (err) {
            commit('contactUpdateErr', err);
        }
    },

    async contactDelete({commit}, id) {
        await DataService.delete(`/contacts/${id}`).then((response) => {

            notification.success({
                message: response.data.message,
                placement: 'topRight'
            });
        }).catch((error) => {
            commit('contactDeleteErr', error);
        });
    },

};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
  };